import { FieldMappingType } from '@monetize/types/app';

export const MN_ACC_FIELDS: FieldMappingType = {
  system: 'monetizenow',
  companies: [],
  deals: [],
  contacts: [],
  Account: [],
  Quote: [],
  Contact: [],
  LegalEntity: [],
  Opportunity: [],
  CreditNote: [],
  CreditMemo: [],
  Invoice: [],
  Product: [],
  Offering: [],
  Product2: [],
  products: [],
};
